import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { signInUser } from "../store";

export const useEpoljoprivredaLogin = () => {
    const dispatch = useDispatch();
    const [processedToken, setProcessedToken] = useState<string | null>(null);
    const [renewed, setRenewed] = useState(false);
    const isRenewing = useSelector((state: RootState) => state.signIn.isRenewing);

    useEffect(() => {
        const params = new URLSearchParams(globalThis.location?.search);
        const token = params.get("token");
        
        if (isRenewing) {
            setRenewed(true);
        } else if (token) {
            if (renewed || token !== processedToken) {
                const paramsObj = Object.fromEntries(params);
                dispatch(signInUser({ token: paramsObj.token, returnUrl: paramsObj.returnUrl }));
                setProcessedToken(token);
                params.delete("token");
                const newSearch = params.toString();
                globalThis.history.replaceState(null, "", newSearch ? `?${newSearch}` : globalThis.location.pathname);
            }
        }
    }, [globalThis.location?.search, dispatch, isRenewing, renewed, processedToken]);
};

export const useEpoljoprivredaData = () => {
    const params = new URLSearchParams(globalThis.location?.search);
    return {
        token: params.get("token") ?? undefined,
        returnUrl: params.get("returnUrl") ?? undefined,
    };
};
